import { render, staticRenderFns } from "./LeadsFromAdsPage.vue?vue&type=template&id=539b3d4e&"
import script from "./LeadsFromAdsPage.vue?vue&type=script&lang=ts&"
export * from "./LeadsFromAdsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports